<template>
  <div class="tableWithPerPageSelection" v-if="critereRecherche">
    <div class="entete border-entete" v-if="contacts">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeContacts.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <router-link :to="{name: 'm.bodac.clients/contacts-addContact' }">
              <a class="button is-addOrEdit"
                 :class="{
                   'button-access-no-permission' : !checkPermissions(permClientsContacts.maj)
                   }"
              >
                {{ $t('listeContacts.actions.newCustomer')}}
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
          <selecteur-action
            @handleAction="manageActions"
            :options='actions'
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="getAllContactSelected().length > 0"
          ></selecteur-action>
        </div>
          <form @submit.prevent="recherche()"
                class="column is-narrow pdr-0">
            <b-input :placeholder="$t('listeContacts.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeContacts.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permClientsContacts.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options"
      @loaded="finLoading" @loading="debutLoading"
      :ref="referenceTable"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"
                    :value="props.row">
        </b-checkbox>
      </div>
      <div slot="cliNom" slot-scope="props">
        <router-link :to="{ name: 'c.bodac.clients/contacts-client',
          params: {id: props.row.tiersId}}"
                     class="has-background-transparent lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(permClientsContacts.lecture)}">
          {{props.row.tiers.nomCommercial}}
        </router-link>
      </div>
      <div slot="nom" slot-scope="props">
        <router-link
          :to="{ name: 'c.bodac.clients/contacts-contacts', params: {id: props.row.id} }"
          :class="{'text-access-no-permission' : !checkPermissions(permClientsContacts.lecture)}"
          class="lien">
          {{props.row.nom}}
        </router-link>
      </div>
      <div slot="newsletter" slot-scope="props" class="has-text-centered">
        <checkbox-async
          v-model="props.row.newsletter"
          :id="props.row.id"
          :maj="updatNewsletter"
          :tooltip-position="'is-left'">
        </checkbox-async>
      </div>
      <div slot="modifier" slot-scope="props" class="has-text-centered">
        <router-link :to="{
          name: 'm.bodac.clients/contacts-editContact', params: {id: props.row.id}
          }">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{ 'text-access-no-permission' : !checkPermissions(permClientsContacts.maj) }"
          >
          </b-icon>
        </router-link>
      </div>
      <div slot="archiver" slot-scope="props" class="has-text-centered">
        <archive-list-button
          :query="() => archiver([props.row.id])"
          :permissions="permClientsContacts.supprimer"
          :title="$t(`general.archiver.${props.row.archive ? 'reactive': 'titre'}`,
              { type: $t('supprimerContact.type') })"
          :successMessage="$t('archiverContact.archiveSuccess')"
          @done="recherche()"
          :actif="!props.row.archive"/>
      </div>
      <div slot="supprimer" class="has-text-centered" slot-scope="props">
        <a @click="checkPermissions(permClientsContacts.supprimer) ?
          supprimerContact(props.row) : showPopUp()">
          <b-icon
            icon="delete-forever"
            type="is-danger"
            :class="{
              'text-access-no-permission' : !checkPermissions(permClientsContacts.supprimer)
              }"
          >
          </b-icon>
        </a>
      </div>
    </v-server-table>
    <b-modal v-model="isComponentSupprimerContact"
             has-modal-card
             class="modal">
      <pop-up-prevention
        oncancel="closePopUpSupprimer"
        :messHeader="idsToDelete.length === 1
          ? this.$t('supprimerContact.delete') : this.$t('supprimerContact.deleteMultiple') "
        :messFooter="this.$t('supprimerContact.irreversible')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesPopup"
        :isErrorPopup.sync="isErrorPopup"
        @yes="supprimerClient"
        @no="closePopUpSupprimer"/>
    </b-modal>
    <b-modal v-model="openPopUpNewsletter"
      has-modal-card
      class="modal">
      <pop-up-prevention
        oncancel="closePopUpNewsletter"
        :messHeader="$t('listeContacts.popUpNewsletterTitle')"
        :labelCheckbox="this.$t('listeContacts.table.newsLetter')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesPopup"
        :isErrorPopup.sync="isErrorPopup"
        @yes="updateEnMasseNewsletter"
        @no="closePopUpNewsletter"/>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-contact ref="filtreListeContact"
                             @toggleFiltre="setShowFiltre"
                             v-model="critereRecherche"
                             @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import { deleteAllContacts, archiver, updateNewsletter } from '@/api/contacts/index';
import popUpPrevention from '@/components/general/popUpPrevention';
import AppBreadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import { TIERS } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import filtreListeContact from '@/components/clients/filtre/filtreListeContact';
import TableItemsInView from '@/components/general/TableItemsInView';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import transform from '@/services/tiers/filters/contactServerTableDataTransformer';
import genererCritereRecherche from '@/services/contact/genererCritereRechercheContact';
import validation from '@/services/contact/validation';
import {
  ACTION_MASS_DELETE,
} from '@/configuration/general/actionsConf';
import selecteurAction from '@/components/general/selecteurAction';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_CONTACTS } from '@/configuration/general/referenceTableConf';
import archiveListButton from '@/components/general/button/archiveListButton';
import checkboxAsync from '@/components/general/checkboxAsync';
import { ACTION_MASS_UPDATE_NEWSLETTER } from '@/configuration/bodac/contact/contactConf';

const Clients = createNamespacedHelpers('clients');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'liste-contacts',
  data() {
    return {
      critereRecherche: null,
      isComponentSupprimerContact: false,
      contactSelectionne: false,
      showFiltre: false,
      loadingComponent: null,
      rechercheInput: null,
      messagesPopup: [''],
      isErrorPopup: false,
      permClientsContacts: TIERS,
      unsubscribeValue: null,
      type: tiersConf.TIERS_TYPE_CLIENT,
      actions: [
        { action: ACTION_MASS_DELETE, translation: 'listeContacts.actions.delete' },
        { action: ACTION_MASS_UPDATE_NEWSLETTER, translation: 'listeContacts.actions.newsletter' },
      ],
      idsToDelete: [],
      referenceTable: REFERENCE_TABLE_CONTACTS,
      mountedLoadingEnd: false,
      startArrayRendering: false,
      archiver,
      openPopUpNewsletter: false,
    };
  },

  components: {
    popUpPrevention,
    AppBreadcrumb,
    filtreListeContact,
    TableItemsInView,
    selecteurAction,
    archiveListButton,
    parametrageTable,
    exportExcelButton,
    checkboxAsync,
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
    this.critereRecherche = genererCritereRecherche();
    if (this.$route.params.type) {
      this.type = this.$route.params.type;
    }
    this.mountedLoadingEnd = true;
    this.setInformationPage(this.$t('pageGescom.contact.liste'));
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...Clients.mapGetters({
      contacts: 'contacts',
      totalContacts: 'totalContacts',
      lastPayload: 'lastPayloadContact',
    }),
    ...Clients.mapGetters({
      allContacts: 'contacts',
    }),
    nombreCritere() {
      let nombreCritere = 0;
      nombreCritere += this.critereRecherche.archive !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.tiers.length ? 1 : 0;
      nombreCritere += this.critereRecherche.marqueIds.length ? 1 : 0;
      nombreCritere += this.critereRecherche.newsletter !== null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeContacts.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeContacts.title'), route: { name: 'l.bodac.clients/contacts-contacts' }, isActive: true },
      ];
      return output;
    },
    iconSelectTotal() {
      if (this.allContactSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      return ['selected', 'cliNom', 'nom', 'prenom', 'service', 'fonction', 'telephone', 'portable', 'email', 'newsletter', 'modifier', 'archiver', 'supprimer'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          cliNom: this.$i18n.t('listeContacts.table.customer'),
          nom: this.$i18n.t('listeContacts.table.name'),
          prenom: this.$i18n.t('listeContacts.table.firstname'),
          service: this.$i18n.t('listeContacts.table.office'),
          fonction: this.$i18n.t('listeContacts.table.role'),
          telephone: this.$i18n.t('listeContacts.table.phone'),
          portable: this.$i18n.t('listeContacts.table.cellPhone'),
          email: this.$i18n.t('listeContacts.table.email'),
          newsletter: this.$i18n.t('listeContacts.table.newsLetter'),
          modifier: '',
          archiver: '',
          supprimer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: ['cliNom', 'nom', 'prenom', 'service', 'fonction', 'telephone', 'portable', 'email', 'newsletter'],
        columnsClasses: {
          selected: 'colonneSelected',
          portable: 'colonneTelephone',
          telephone: 'colonneTelephone',
          newsletter: 'is-relative',
        },
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          data.query.type = this.type;
          data.query.sousType = [tiersConf.TIERS_SOUS_TYPE_AUCUN];
          if (data.query.tiers && data.query.tiers.length > 0) {
            data.query.tiersId = data.query.tiers.map((t) => t.id);
          }
          delete data.query.tiers;
          return this.actionsLoadContacts(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.contacts,
            count: this.totalContacts,
          };
        }),
      };
    },
    allContactSelected() {
      return this.getAllContactSelected().length === this.contacts.length;
    },
    exportExcelQuery() {
      return {
        typeDonnee: tiersConf.EXPORT_EXCEL_CONTACTS,
        typeExport: null,
        filtres: transform(this.lastPayload),
      };
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Clients.mapActions({
      actionsLoadContacts: 'loadContacts',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeContact.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    closePopUpSupprimer() {
      this.isComponentSupprimerContact = false;
      this.messagesPopup = [];
      this.isErrorPopup = false;
    },
    async supprimerClient() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (!this.allContacts) {
          await this.loadContacts();
        }
        await deleteAllContacts(this.idsToDelete);
        this.isComponentSupprimerContact = false;
        messageSucces(this.idsToDelete.length === 1
          ? this.$i18n.t('supprimerContact.messages.suppression') : this.$i18n.t('supprimerContact.messages.suppressionMultiple'));
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          this.messagesPopup = [];
          validation(e.response, this.messagesPopup);
          this.isErrorPopup = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async loadContacts() {
      try {
        await this.actionsLoadContacts();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      }
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].query = this.critereRecherche;
      this.$refs[this.referenceTable].refresh();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },

    getAllContactSelected() {
      return this.contacts.filter((el) => {
        return el.selected;
      });
    },
    selectAll() {
      const selectValue = !this.allContactSelected;
      this.contacts.forEach((el) => {
        el.selected = selectValue;
      });
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    supprimerContact(props) {
      this.isComponentSupprimerContact = true;
      this.idsToDelete = [props.id];
      this.messagesPopup = [];
      this.isErrorPopup = false;
    },
    manageActions(action) {
      switch (action) {
        case ACTION_MASS_DELETE:
          if (this.checkPermissions(this.permClientsContacts.supprimer)) {
            this.messagesPopup = [];
            this.isErrorPopup = false;
            this.isComponentSupprimerContact = true;
            this.idsToDelete = this.getAllContactSelected().map((contact => contact.id));
          } else this.showPopUp();
          break;
        case ACTION_MASS_UPDATE_NEWSLETTER:
          if (this.checkPermissions(this.permClientsContacts.maj)) {
            this.messagesPopup = [];
            this.isErrorPopup = false;
            this.openPopUpNewsletter = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('general.noActionSelect'));
          break;
      }
    },
    async reinitialiser() {
      await this.$refs.filtreListeContact.initializeFiltre();
      this.$refs.filtreListeContact.viderCritere();
      this.$refs.filtreListeContact.appliquerCritere();
      this.showFiltre = false;
    },
    updatNewsletter(id, newsletter) {
      return updateNewsletter({ ids: [id], newsletter: newsletter });
    },
    async updateEnMasseNewsletter(newsletter) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateNewsletter({
          ids: this.getAllContactSelected().map((contact => contact.id)),
          newsletter: newsletter,
        });
        this.openPopUpNewsletter = false;
        messageSucces(this.$i18n.t('listeContacts.popUpNewsletterMsgSuccess'));
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    closePopUpNewsletter() {
      this.openPopUpNewsletter = false;
      this.messagesPopup = [];
      this.isErrorPopup = false;
    },
  },
};
</script>

<style>

</style>
